import { useAnnouncementPreviewRequest } from '@components/announcement/hooks/useAnnouncementPreviewRequest.hooks';
import { type AnnouncementItemEditorState } from '@components/announcement/util/announcementItemEditorState.util';
import { useState } from 'react';
import { usePreviewAnnouncementQuery } from '@/hooks';
import { type AnnouncementRichTextContentDTO } from '@/model';

interface UseAnnouncementPreviewProps {
  editorState: AnnouncementItemEditorState;
  richTextContent: AnnouncementRichTextContentDTO;
}

export const useAnnouncementPreview = ({
  editorState,
  richTextContent,
}: UseAnnouncementPreviewProps) => {
  const [blackAndWhitePreview, setBlackAndWhitePreview] = useState(false);
  const [automaticPreview, setAutomaticPreview] = useState(true);

  const { previewRequest, isPreviewRequestPending } = useAnnouncementPreviewRequest({
    editorState,
    backgroundColor: editorState.backgroundColor,
    richTextContent,
    blackAndWhite: blackAndWhitePreview,
    automaticPreview,
  });

  const previewQuery = usePreviewAnnouncementQuery(previewRequest, automaticPreview);
  const previewResult = previewQuery.data;

  return {
    blackAndWhitePreview,
    onBlackAndWhitePreviewChange: setBlackAndWhitePreview,
    automaticPreview,
    onAutomaticPreviewChange: setAutomaticPreview,
    onGeneratePreview: () => previewQuery.refetch(),
    previewImage: previewResult?.isSuccess ? previewResult.data.content : undefined,
    isPreviewPending: previewQuery.isFetching || isPreviewRequestPending,
    isPreviewError: previewResult ? !previewResult.isSuccess : false,
  };
};
